import css from './MessageCenter.scss'

const MessageCenter = () => (
  <h6 className={css.dropdownHeader}>Notifications</h6>
)

export default MessageCenter
